import { EXPERIMENT_VARIANTS_HEADER } from '@lib/constants/cookies';
import { FlagVariant } from '@lib/flags';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';

type CookieStore = {
  get(name: string): { value: string } | undefined;
};

export const getFeatureFlagVariant = (
  cookies: CookieStore,
  flagName: Flags
): FlagVariant | undefined => {
  const variants = cookies.get(EXPERIMENT_VARIANTS_HEADER)?.value;
  let parsedVariants: Record<string, FlagVariant | undefined> = {};
  if (variants) {
    // JSON.parse can succeed with `null` (the literal cookie value "null"),
    // which would throw on the flag lookup below.
    try {
      parsedVariants = JSON.parse(variants) ?? {};
    } catch {
      try {
        parsedVariants = JSON.parse(decodeURIComponent(variants)) ?? {};
      } catch {
        parsedVariants = {};
      }
    }
  }
  return parsedVariants[flagName];
};

export const isFeatureFlagEnabled = (
  cookies: CookieStore,
  flagName: Flags,
  flagValue: string
): boolean => getFeatureFlagVariant(cookies, flagName)?.key === flagValue;

export const isReviewsFeatureEnabled = (cookies: CookieStore): boolean => {
  return isFeatureFlagEnabled(cookies, Flags.UPM_REVIEWS, FLAG_TREATMENT);
};

export const isSearchSsrEnabled = (cookies: CookieStore): boolean => {
  return isFeatureFlagEnabled(cookies, Flags.SEARCH_SSR, FLAG_TREATMENT);
};
